var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-grid',{ref:"tableGrid",attrs:{"search-table":"","headers":_vm.headers,"items":_vm.regTypes,"loading":_vm.loading,"multiple":true,"noPagination":true},on:{"select":_vm.selectRegType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }